import { Form, Space } from 'antd'
import { ExternalLinkEditorProps } from './types'
import ExternalLinkEditorMessages from './components/ExternalLinkEditorMessages'
import ExternalLinkEditorProvider from './components/ExternalLinkEditorContext'
import ExternalLinkEditorButtons from './components/ExternalLinkEditorButtons'
import ExternalLinkEditorRow from './components/ExternalLinkEditorRow'
import { HelpMessage } from 'utils/constants'
import CIMSSection from 'components/CIMSSection'

/**
 * returns a {@link Form.List} of external links for the user to add/edit/remove
 *
 * @param props {@link ExternalLinkEditorProps}
 * @see {@link ExternalLinkEditorValues}
 */
const ExternalLinkEditor: React.FC<ExternalLinkEditorProps> = (props) => (
  <Form.List name="externalLinks">
    {(fields, operation) => (
      <ExternalLinkEditorProvider {...props} {...operation}>
        <CIMSSection
          help={HelpMessage.ExternalLinkEditor}
          title="External Links"
        >
          <Space
            direction="vertical"
            size="small"
            style={{ marginBottom: '1rem' }}
          >
            <ExternalLinkEditorMessages />
            <ExternalLinkEditorButtons />
          </Space>
          {fields.map(({ key, ...rest }) => (
            <ExternalLinkEditorRow key={key} {...rest} />
          ))}
        </CIMSSection>
      </ExternalLinkEditorProvider>
    )}
  </Form.List>
)

export default ExternalLinkEditor
